import { render, staticRenderFns } from "./ImageRouteComponent.vue?vue&type=template&id=7219d4e7&"
import script from "./ImageRouteComponent.vue?vue&type=script&lang=js&"
export * from "./ImageRouteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports